// src/data/batteriesData.js - Contains all battery product data

export const batteriesData = [
  {
    id: "amped-30ah-lifepo4",
    name: "Amped Outdoors 30Ah Lithium Battery (LiFePO4) Wide",
    capacity: "30Ah",
    type: "LiFePO4",
    nominalVoltage: "12.8V",
    actualVoltage: "12.8V",
    dischargeCutOff: "10V",
    chargeCutOff: "14.65V",
    chargeTemp: "32F - 113F",
    dischargeTemp: "-20F - 140F",
    weight: "6lbs 10oz",
    dimensions: "5 7/8\" x 3 29/32\" x 5 1/8\"",
    contDischarge: "15A",
    chargeCurrent: "15A",
    chargeCycles: "2000+",
    warranty: "5 years",
    wattHours: "384Wh", // 30Ah x 12.8V = 384Wh
    hasBluetooth: false,
    msrp: 189.99, // Updated price from website
    image: "/images/batteries/amped-30ah-battery.webp",
    fallbackImage: "/images/batteries/amped-30ah-battery.webp",
    description: "LiFePO4 battery perfect for ice fishing, shuttles, and portable units",
    notes: "Fits Clam Battery Tray, Portable Power Boxes, and various portable shuttles",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: true,
    chargerMSRP: 40.00, // Estimated price based on total bundle price
    chargerDetails: "3A Lithium Charger (10hr charge time)",
    runtime: "Varies by unit - see website for runtime charts",
    variants: {
      withCharger: {
        id: "amped-30ah-lifepo4-with-charger",
        msrp: 229.99, // Battery + Charger price
        name: "Amped Outdoors 30Ah LiFePO4 + 3A Charger",
        description: "30Ah LiFePO4 battery with 3A lithium charger (10hr charge time)"
      },
      withoutCharger: {
        id: "amped-30ah-lifepo4",
        msrp: 189.99, // Battery only price
        name: "Amped Outdoors 30Ah LiFePO4 Battery Only",
        description: "30Ah LiFePO4 battery only"
      }
    }
  },
  {
    id: "amped-32ah-nmc-with-charger",
    name: "Amped Outdoors 32Ah NMC + 5A Charger with Bluetooth",
    capacity: "32Ah",
    type: "NMC",
    nominalVoltage: "14.8V",
    actualVoltage: "14.8V",
    dischargeCutOff: "10V",
    chargeCutOff: "16.8V",
    chargeTemp: "32F - 113F",
    dischargeTemp: "-4F - 140F",
    weight: "Approx 4.0lbs",
    dimensions: "5 7/8\" x 3 29/32\" x 3 5/8\"",
    contDischarge: "20A",
    chargeCurrent: "15A",
    chargeCycles: "1000+",
    warranty: "5 years",
    wattHours: "467Wh",
    msrp: 389.98,
    image: "/images/batteries/amped-32ah-nmc-battery.png",
    fallbackImage: "/images/batteries/amped-32ah-nmc-battery.png",
    description: "High-capacity 32Ah NMC battery with smart 5A charger included and Bluetooth connectivity",
    notes: "Excellent for extended use and high-performance electronics. Includes Bluetooth for battery monitoring.",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: false,
    chargerDetails: "Smart 14.8V/5A NMC Charger included (6hr charge time)",
    runtime: "Up to 22 hours depending on the device",
    hasBluetooth: true
  },
  {
    id: "amped-8ah-lifepo4",
    name: "Amped Outdoors 8Ah Lithium Battery (LiFePO4)",
    capacity: "8Ah",
    type: "LiFePO4",
    nominalVoltage: "12V",
    actualVoltage: "12.8V", // Standard for LiFePO4 batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "14.6V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-20F - 140F", // Estimated based on other Amped batteries
    weight: "1lb 11oz",
    dimensions: "5 7/8\" x 2 5/8\" x 3 5/8\"",
    contDischarge: "10A", // Estimated based on battery size
    chargeCurrent: "3A", // Based on charger
    chargeCycles: "2000+",
    warranty: "5 years",
    wattHours: "96Wh",
    hasBluetooth: false,
    msrp: 54.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/2_30b48e8c-3783-41b6-b69b-0a056839a857.png?v=1725448501&width=1946",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/2_30b48e8c-3783-41b6-b69b-0a056839a857.png?v=1725448501&width=1946",
    description: "Compact LiFePO4 battery ideal for small fish finders and portable units",
    notes: "Lightweight and portable solution for day trips and small setups",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: true,
    chargerMSRP: 19.99, // Calculated from the difference between variants
    chargerDetails: "3A Lithium Charger (3hr charge time)",
    runtime: "Varies by unit - perfect for day trips",
    variants: {
      withCharger: {
        id: "amped-8ah-lifepo4-with-charger",
        msrp: 74.98, // Battery + Charger price
        name: "Amped Outdoors 8Ah LiFePO4 + 3A Charger",
        description: "8Ah LiFePO4 battery with 3A lithium charger (3hr charge time)"
      },
      withoutCharger: {
        id: "amped-8ah-lifepo4",
        msrp: 54.99, // Battery only price
        name: "Amped Outdoors 8Ah LiFePO4 Battery Only",
        description: "8Ah LiFePO4 battery only"
      }
    }
  },
  {
    id: "amped-15ah-lifepo4",
    name: "Amped Outdoors 15Ah Lithium Battery (LiFePO4)",
    capacity: "15Ah",
    type: "LiFePO4",
    nominalVoltage: "12V",
    actualVoltage: "12.8V", // Standard for LiFePO4 batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "14.6V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-20F - 140F", // Estimated based on other Amped batteries
    weight: "3.3 lbs",
    dimensions: "5 7/8\" x 2 1/2\" x 3 5/8\"",
    contDischarge: "15A", // Estimated based on battery size
    chargeCurrent: "3A", // Based on charger
    chargeCycles: "2000+",
    warranty: "5 years",
    wattHours: "192Wh",
    hasBluetooth: false,
    msrp: 99.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_-_Copy.png?v=1736952356&width=1946",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_-_Copy.png?v=1736952356&width=1946",
    description: "Mid-size LiFePO4 battery perfect for fish finders and portable electronic devices",
    notes: "Balanced size and capacity for day-long fishing trips",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: true,
    chargerMSRP: 19.99, // Calculated from the difference between variants
    chargerDetails: "3A Lithium Charger (5hr charge time)",
    runtime: "Varies by unit - ideal for full-day usage",
    variants: {
      withCharger: {
        id: "amped-15ah-lifepo4-with-charger",
        msrp: 119.98, // Battery + Charger price
        name: "Amped Outdoors 15Ah LiFePO4 + 3A Charger",
        description: "15Ah LiFePO4 battery with 3A lithium charger (5hr charge time)"
      },
      withoutCharger: {
        id: "amped-15ah-lifepo4",
        msrp: 99.99, // Battery only price
        name: "Amped Outdoors 15Ah LiFePO4 Battery Only",
        description: "15Ah LiFePO4 battery only"
      }
    }
  },
  {
    id: "amped-19ah-nmc-with-charger",
    name: "Amped Outdoors 19Ah NMC + 5A Charger",
    capacity: "19Ah",
    type: "NMC",
    nominalVoltage: "14.8V",
    actualVoltage: "14.8V", // Standard for NMC batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "16.8V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-4F - 140F", // Estimated based on other Amped NMC batteries
    weight: "2lb 15oz",
    dimensions: "5 7/8\" x 2 1/2\" x 3 5/8\"",
    contDischarge: "15A", // Estimated based on battery size
    chargeCurrent: "5A", // Based on charger
    chargeCycles: "1000+",
    warranty: "5 years",
    wattHours: "285Wh",
    hasBluetooth: false,
    msrp: 169.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/1-Photoroom_1.png?v=1734524623&width=1946",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/1-Photoroom_1.png?v=1734524623&width=1946",
    description: "Mid-capacity 19Ah NMC battery with smart 5A charger included",
    notes: "Powerful and lightweight NMC battery perfect for fish finders and portable electronics",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: false,
    chargerDetails: "Smart 14.8V/5A NMC Charger included (4hr charge time)",
    runtime: "Up to 15 hours depending on the device"
  },
  {
    id: "amped-20ah-lifepo4",
    name: "Amped Outdoors 20Ah Lithium Battery (LiFePO4)",
    capacity: "20Ah",
    type: "LiFePO4",
    nominalVoltage: "12V",
    actualVoltage: "12.8V", // Standard for LiFePO4 batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "14.6V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-20F - 140F", // Estimated based on other Amped batteries
    weight: "4lbs",
    dimensions: "5 7/8\" x 3 29/32\" x 3 5/8\"",
    contDischarge: "15A", // Estimated based on battery size
    chargeCurrent: "3A", // Based on charger
    chargeCycles: "2000+",
    warranty: "5 years",
    wattHours: "256Wh",
    hasBluetooth: false,
    msrp: 129.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_2_-Copy.png?v=1734524518",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_2_-Copy.png?v=1734524518",
    description: "Mid-to-high capacity LiFePO4 battery ideal for fish finders and portable setups",
    notes: "Great balance of capacity and size for extended fishing trips",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: true,
    chargerMSRP: 19.99, // Calculated from the difference between variants
    chargerDetails: "3A Lithium Charger (7hr charge time)",
    runtime: "Varies by unit - ideal for extended usage",
    variants: {
      withCharger: {
        id: "amped-20ah-lifepo4-with-charger",
        msrp: 149.98, // Battery + Charger price
        name: "Amped Outdoors 20Ah LiFePO4 + 3A Charger",
        description: "20Ah LiFePO4 battery with 3A lithium charger (7hr charge time)"
      },
      withoutCharger: {
        id: "amped-20ah-lifepo4",
        msrp: 129.99, // Battery only price
        name: "Amped Outdoors 20Ah LiFePO4 Battery Only",
        description: "20Ah LiFePO4 battery only"
      }
    }
  },
  {
    id: "amped-52ah-nmc-with-charger",
    name: "Amped Outdoors 52Ah NMC + 5A Charger",
    capacity: "52Ah",
    type: "NMC",
    nominalVoltage: "14.8V",
    actualVoltage: "14.8V", // Standard for NMC batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "16.8V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-4F - 140F", // Estimated based on other Amped NMC batteries
    weight: "7lb 1oz",
    dimensions: "5 7/8\" x 3 29/32\" x 5 1/8\"",
    contDischarge: "25A", // Estimated based on battery size
    chargeCurrent: "5A", // Based on charger
    chargeCycles: "1000+",
    warranty: "5 years",
    wattHours: "769.6Wh",
    hasBluetooth: false,
    msrp: 359.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_6_-_Copy.png?v=1734524377&width=950",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_6_-_Copy.png?v=1734524377&width=950",
    description: "High-capacity 52Ah NMC battery with smart 5A charger included",
    notes: "Our largest NMC battery - perfect for extended fishing trips and powering high-draw electronics",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: false,
    chargerDetails: "Smart 14.8V/5A NMC Charger included (10hr charge time)",
    runtime: "Up to 35 hours depending on the device"
  },
  {
    id: "amped-52ah-nmc-bluetooth-with-charger",
    name: "Amped Outdoors 52Ah NMC + 5A Charger with Bluetooth",
    capacity: "52Ah",
    type: "NMC",
    nominalVoltage: "14.8V",
    actualVoltage: "14.8V", // Standard for NMC batteries
    dischargeCutOff: "10V", // Estimated based on other Amped batteries
    chargeCutOff: "16.8V", // Estimated based on other Amped batteries
    chargeTemp: "32F - 113F", // Estimated based on other Amped batteries
    dischargeTemp: "-4F - 140F", // Estimated based on other Amped NMC batteries
    weight: "7lb 1oz",
    dimensions: "5 7/8\" x 3 29/32\" x 5 1/8\"",
    contDischarge: "25A", // Estimated based on battery size
    chargeCurrent: "5A", // Based on charger
    chargeCycles: "1000+",
    warranty: "5 years",
    wattHours: "769.6Wh",
    hasBluetooth: true,
    msrp: 369.99,
    image: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_6_-_Copy.png?v=1734524377&width=950",
    fallbackImage: "https://ampedoutdoors.com/cdn/shop/files/2-Photoroom_6_-_Copy.png?v=1734524377&width=950",
    description: "High-capacity 52Ah NMC battery with smart 5A charger included and Bluetooth connectivity",
    notes: "Our largest NMC battery with Bluetooth monitoring - perfect for extended fishing trips and real-time battery status",
    dealInfo: "10% OFF with our link at Amped Outdoors checkout!",
    hasChargerOption: false,
    chargerDetails: "Smart 14.8V/5A NMC Charger included (10hr charge time)",
    runtime: "Up to 35 hours depending on the device"
  },
  // Add more batteries as needed
];